import { whatsappLink, DEFAULT_WA_MESSAGE } from "@/lib/config";

const WhatsAppIcon = ({ className }) => (
    <svg viewBox="0 0 32 32" className={className} fill="currentColor" aria-hidden="true">
        <path d="M16.004 0h-.008C7.174 0 .002 7.174.002 16c0 3.5 1.13 6.747 3.05 9.38L1.06 31.27l6.067-1.94A15.9 15.9 0 0 0 16.004 32C24.83 32 32 24.826 32 16S24.83 0 16.004 0zm9.31 22.594c-.386 1.09-1.92 1.995-3.144 2.26-.836.178-1.928.32-5.604-1.204-4.7-1.948-7.726-6.724-7.962-7.034-.226-.31-1.9-2.53-1.9-4.826 0-2.296 1.166-3.424 1.636-3.904.386-.396.844-.576 1.126-.576.366 0 .67.004.936.018.3.014.7-.114 1.094.834.404.972 1.374 3.36 1.494 3.604.122.244.204.53.04.84-.154.31-.232.502-.46.772-.232.27-.484.602-.69.808-.232.23-.474.48-.204.94.27.46 1.2 1.98 2.578 3.208 1.77 1.578 3.262 2.066 3.722 2.296.46.232.728.194.996-.116.27-.31 1.15-1.342 1.456-1.804.302-.46.61-.384 1.026-.23.42.154 2.658 1.252 3.116 1.48.46.232.764.346.876.538.116.192.116 1.108-.27 2.176z" />
    </svg>
);

export const WhatsAppButton = () => {
    return (
        <a
            data-testid="floating-whatsapp-btn"
            href={whatsappLink(DEFAULT_WA_MESSAGE)}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="WhatsApp Kontakt"
            className="fixed bottom-6 right-5 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg shadow-black/40 animate-pulse-glow hover:scale-105 transition-transform"
        >
            <WhatsAppIcon className="h-7 w-7" />
        </a>
    );
};

export default WhatsAppButton;
